import { combineReducers } from 'redux';
import LoginReducer from './LoginReducer';
import LoaderReducer from './LoaderReducer';

export default combineReducers({
    LoginReducer,
    LoaderReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js